module.exports = __webpack_public_path__ + "static/media/petal_bg.de1cbe03.svg";